import axios from 'axios'
import { addContextToFormData } from 'components/document-context/helper'

export class ChatBotAPIService {
  static generateRequest(data, segment, method = 'POST', signal) {
    if (method === 'POST') {
      return fetch(`${axios.defaults.baseURL}/api${segment}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: axios.defaults.headers.common['Authorization'],
          application: 'eleo',
        },
        ...signal,
      })
    } else {
      return fetch(`${axios.defaults.baseURL}/api${segment}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: axios.defaults.headers.common['Authorization'],
          application: 'eleo',
        },
      })
    }
  }

  static async generateChatBot(params) {
    delete params.wordsConsumed

    const { context, ...data } = params
    data.chatBotId = params.selectedChatBot || params.newId

    let formData = new FormData()
    formData = await addContextToFormData(formData, context)
    formData.append('data', JSON.stringify(data))

    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    return await axios.post('api/chat-bot/create', formData, config)
    // return this.generateRequest(data, '/chat-bot/create', 'POST')
  }

  static async generateChatBotDraft(params) {
    delete params.wordsConsumed

    const data = {
      data: {
        ...params,
        originalChatBotId: params.selectedChatBot || null,
        tone: params.tone ?? null,
        storyId: params.storyId ?? null,
        intro: params.intro,
      },
    }
    return this.generateRequest(data, '/chat-bot/draft/create', 'POST')
  }

  static async deleteChatBot(data) {
    return this.generateRequest(data, '/chat-bot/delete', 'POST')
  }

  static async getChatBotList(data) {
    return this.generateRequest(data, '/chat-bot/list', 'GET')
  }

  static async getRecentLibraryChatBots(data) {
    return this.generateRequest(data, '/chat-bot/library/recent', 'GET')
  }
}
